import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IEntityVersion } from '../model/entity/EntityVersion';
import type { IEntityVersionSearchParams } from '../api/requests/entities/entityVersionApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useFindEntitiesResult {
    isLoaded: boolean;
    entityVersions: IEntityVersion[];
}

export const useFindEntities = (searchParams: IEntityVersionSearchParams) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useFindEntitiesResult>(() => ({ isLoaded: false, entityVersions: [] }));

    useEffect(() => {
        setResult({ isLoaded: false, entityVersions: [] });
        rootStore.entityVersionStore.findAllCurrentEntityVersions(searchParams)
            .then((entityVersions) => {
                setResult({ isLoaded: true, entityVersions: entityVersions });
            })
            .catch(e => publishNotification({
                text: `Error finding current entity versions: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.entityVersionStore, publishNotification, rootStore.gameVersionStore.currentGameVersion, searchParams]);

    return result;
};
